import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

const getToken = () => {
    const storedToken = localStorage.getItem("token");

    if (!storedToken) {
        return "";
    }

    try {
        return JSON.parse(storedToken) || "";
    } catch (error) {
        return "";
    }
};

function connectToSocket() {
    const token = getToken();
    const socket = openSocket(getBackendUrl(), {
      transports: ["polling", "websocket"],
      reconnection: true,
      autoConnect: Boolean(token),
      auth: { token },
    });

    const disconnectSocket = socket.disconnect.bind(socket);
    let disposed = false;

    const updateSocketToken = () => {
        if (disposed) return false;

        const nextToken = getToken();

        socket.auth = { token: nextToken };

        if (!nextToken) {
            // Pausar sin liberar: una sesión nueva puede recuperar la pantalla activa.
            disconnectSocket();
            return false;
        }

        return true;
    };

    const refreshSocketToken = () => {
        // Una renovación explícita puede recuperar un rechazo del token anterior.
        // Los errores de red solo actualizan auth y conservan el reintento nativo.
        if (updateSocketToken() && !socket.connected) {
            socket.connect();
        }
    };

    socket.on("connect_error", updateSocketToken);
    socket.io.on("reconnect_attempt", updateSocketToken);
    window.addEventListener("token:refreshed", refreshSocketToken);

    // Los componentes llaman disconnect() al salir. Liberar también el evento
    // global para que renovar sesión no resucite conexiones de pantallas antiguas.
    socket.disconnect = socket.close = () => {
        disposed = true;
        window.removeEventListener("token:refreshed", refreshSocketToken);
        socket.off("connect_error", updateSocketToken);
        socket.io.off("reconnect_attempt", updateSocketToken);
        return disconnectSocket();
    };

    return socket;
}

export default connectToSocket;
